import TextField from '@mui/material/TextField';
import { useCallback, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ACTIONS from '../../../redux/action';
import i18n from '../../../utils/i18n';
import Navigation from '../../regFlow/components/navigation/navigation';
import RadioInput from '../../regFlow/components/searchInputs/radioInput';
import { industryInput } from '../data/kftRgFlowText';

const Industry = ({ ...props }) => {
	const [industryError, setIndustryError] = useState(false);
	const companyStore = useSelector((state) => state.company_store);
	const [inputError, setInputError] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');
	const [filteredIndustries, setFilteredIndustries] = useState(industryInput());
	const dispatch = useDispatch();

	const handleNext = useCallback(
		(inc) => {
			props.handleNext(inc);
		},
		[props]
	);

	const handleBack = useCallback(
		(decr) => {
			props.handleBack(decr);
		},
		[props]
	);

	useEffect(() => {
		const inputField = document.getElementById('industryinput');
		if (companyStore.industry === 'other') {
			const stepContainer = inputField?.closest('.stepContainer');
			if (stepContainer) {
				setTimeout(() => {
					const containerHeight = stepContainer.clientHeight;
					const containerScrollHeight = stepContainer.scrollHeight;
					const scrollPosition = containerScrollHeight - containerHeight;
					stepContainer.scrollTo({
						top: scrollPosition,
						behavior: 'smooth',
					});
					setTimeout(() => {
						if (inputField) {
							inputField.focus();
						}
					}, 300);
				}, 100);
			}
		}
		if (industryError || inputError) {
			const errorField = document.getElementById('error-message');
			if (errorField) {
				errorField.scrollIntoView({ behavior: 'smooth' });
			}
		}
	}, [companyStore.industry, industryError, inputError]);

	const handleSearch = (event) => {
		const term = event.target.value;
		setSearchTerm(term);
		setIndustryError(false);
		setInputError(false);

		if (term.length >= 2) {
			const filtered = industryInput().filter((industry) =>
				industry.label.toLowerCase().includes(term.toLowerCase())
			);

			const otherservices = industryInput().find(
				(industry) => industry.value === 'otherservices'
			);
			const other = industryInput().find(
				(industry) => industry.value === 'other'
			);
			if (
				!filtered.find((industry) => industry.value === 'otherservices') &&
				otherservices
			) {
				filtered.push(otherservices);
			}
			if (!filtered.find((industry) => industry.value === 'other') && other) {
				filtered.push(other);
			}

			setFilteredIndustries(filtered);
		} else {
			setFilteredIndustries(industryInput());
		}
	};

	return (
		<div className="stepContainer">
			<div className="SFInput">
				<p className="SFSubTitle">
					<span className="SFSubTitle">
						{i18n.t('kftregflow.whichIndustryText')}
					</span>
				</p>
				<TextField
					variant="outlined"
					value={searchTerm}
					onChange={handleSearch}
					label={i18n.t('company.searchindustry')}
				/>
				<hr />
				<RadioInput
					storeID="industry"
					dataText={filteredIndustries}
					error={industryError}
				/>

				{companyStore.industry === 'other' && (
					<div
						className="SFMarginTop1rem SFInputWidth100"
						style={{ marginBottom: '16px' }}>
						<TextField
							variant="outlined"
							value={companyStore.industryinput}
							onChange={(event) => {
								dispatch(
									ACTIONS.addCompanyInfo({
										id: event.target.id,
										data: event.target.value,
										stateObject: 'company_store',
									})
								);
								setInputError(false);
								setIndustryError(false);
							}}
							error={inputError}
							id="industryinput"
							name="industryinput"
							label={i18n.t('company.companyindustrylabel')}
						/>
					</div>
				)}
			</div>

			<Navigation
				step={4}
				handleBack={() => handleBack()}
				handleNext={() => handleNext(1)}
				disabledProp={
					companyStore.industry === '' ||
					(companyStore.industry === 'other' &&
						companyStore.industryinput === '')
				}
			/>
		</div>
	);
};

export default withTranslation()(Industry);
